import { gql } from "@apollo/client";

const VERSION = `
  id
  version
  mode
  policy
  note
  createdBy
  createdAt
`;

export const GET_CANCELLATION_POLICY = gql`
  query GetCancellationPolicy {
    getCancellationPolicy {
      status
      message
      current { ${VERSION} }
      defaults
      options
      versions
    }
  }
`;

export const GET_CANCELLATION_POLICY_VERSION = gql`
  query GetCancellationPolicyVersion($id: ID!) {
    getCancellationPolicyVersion(id: $id) {
      status
      message
      version { ${VERSION} }
    }
  }
`;

export const PREVIEW_CANCELLATION_CHARGE = gql`
  query PreviewCancellationCharge($policy: JSON!, $scenario: JSON!) {
    previewCancellationCharge(policy: $policy, scenario: $scenario) {
      status
      message
      result
    }
  }
`;

export const SAVE_CANCELLATION_POLICY = gql`
  mutation SaveCancellationPolicy($policy: JSON!, $mode: String!, $note: String) {
    saveCancellationPolicy(policy: $policy, mode: $mode, note: $note) {
      status
      message
      version { ${VERSION} }
    }
  }
`;

export const GET_CANCELLATION_CHARGES = gql`
  query GetCancellationCharges($filter: JSON, $limit: Int, $offset: Int) {
    getCancellationCharges(filter: $filter, limit: $limit, offset: $offset) {
      status
      message
      total
      rows
      summary
    }
  }
`;

export const GET_ORDER_CANCELLATION_CHARGES = gql`
  query GetOrderCancellationCharges($orderId: ID!) {
    getOrderCancellationCharges(orderId: $orderId) {
      status
      message
      rows
    }
  }
`;

export const WAIVE_CANCELLATION_CHARGE = gql`
  mutation WaiveCancellationCharge($id: ID!, $reason: String!) {
    waiveCancellationCharge(id: $id, reason: $reason) {
      status
      message
      charge
    }
  }
`;
